// Dependencies
import radium from 'radium';
import Button from "../components/button/Button.js";
import {navigateToEntranceIfGiven} from "../lib/nav-util-service.js";
import {connect} from "react-redux";
import {PartnerShopErrors} from "../lib/sponsorCodes-service.js";

function ErrorPage(props) {
    const style = {
        container: {
            margin: 'auto',
        },
        error: {
            fontWeight: '600',
            textAlign: 'center',
        },
        buttonContainer: {
            marginTop: '3em',
        },
    };

    return (
        <div style={style.container}>
            {
                props.failed &&
                <div>
                    <div style={style.error}>
                        Leider ist ein Fehler aufgetreten. < br/>
                        Bitte versuchen Sie es erneut. < br/>
                        < br/>
                        Falls das Problem weiterhin besteht, kontaktieren Sie uns bitte unter 07152 9259 700 oder
                        <a href="mailto:support@leoticket.de"> support@leoticket.de</a>.
                    </div>
                    <Button
                        name="to_startpage"
                        buttonText="Zur Startseite"
                        btnStyle="highlight"
                        buttonContainerStyle={style.buttonContainer}
                        onClick={() => navigateToEntranceIfGiven(props.eventUuid)}
                    />
                </div>
            }
            {
                props.codeWrong &&
                <div>
                    <div style={style.error}>
                        Die aufgerufene Partnershop Adresse ist nicht korrekt.< br/>
                        Achten Sie darauf keine Zeichen auszulassen, falls Sie die Adresse aus einem Dokument
                        kopieren.< br/>
                        Erkundigen Sie sich gegebenenfalls bei der Person, von der Sie die Adresse erhalten haben.< br/>
                        < br/>
                        Falls das Problem weiterhin besteht, kontaktieren Sie uns bitte unter 07152 9259 700 oder
                        <a href="mailto:support@leoticket.de"> support@leoticket.de</a>.
                    </div>
                </div>
            }
        </div>
    );
}

const RadiumErrorPage = radium(ErrorPage)

const mapStateToProps = (state) => {
    console.log(state.sponsorCodes.entranceUrl)
    return {
        entranceUrl: state.sponsorCodes.entranceUrl,
        failed: state.sponsorCodes.partnerShopFailed,
        codeWrong: state.sponsorCodes.partnershopErrors.includes(PartnerShopErrors.INVALID),
        eventUuid: state.event.selected
    }
}

export default connect(
    mapStateToProps,
)(RadiumErrorPage);
